var storefrontApp = angular.module("storefrontApp");

storefrontApp.controller("dynamicPageController", [
    "$scope",
    
    function ($scope) {
        function initialize() {
            $scope.currentPageTitle =
                document.getElementById("hdnPgTitle").value || "";
        }
        initialize();       
    },
]);
